import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentInfo } from '../../interfaces';
import { FavieFileTemp } from '../favie-upload-file/favie-upload-file.component';
import { DEFAULT_DOCUMENT_INFO } from '../../constants';

@Component({
  selector: 'app-additional-documents',
  templateUrl: './additional-documents.component.html',
  styleUrls: ['./additional-documents.component.scss'],
})
export class AdditionalDocumentsComponent {
  public cachedAdditionalDocuments: DocumentInfo[];

  @Input() set additionalDocuments(documents: DocumentInfo[]) {
    this.cachedAdditionalDocuments = documents;
  }
  @Input() public defaultImportInfo = {
    label: 'Button.Import',
    iconUrl: 'assets/icons/icon-import.svg',
  };
  @Input() public storagePath: string;
  @Input() public limitedDocumentNumber = 10;
  @Input() public isDisabled: boolean;

  @Output() public additionalDocumentsChange = new EventEmitter<
    DocumentInfo[]
  >();

  public updateAdditionalDocuments(file: FavieFileTemp, index: number): void {
    if (file) {
      this.cachedAdditionalDocuments[index] = {
        documentUrl: file.url,
        documentName: file.file.name,
        fileSize: file.file.size,
        file,
      };
      if (this.cachedAdditionalDocuments.length < this.limitedDocumentNumber) {
        this.cachedAdditionalDocuments.push({ ...DEFAULT_DOCUMENT_INFO });
      }
    } else {
      this.cachedAdditionalDocuments.splice(index, 1);
      if (this.cachedAdditionalDocuments.length < this.limitedDocumentNumber) {
        this.cachedAdditionalDocuments.push({ ...DEFAULT_DOCUMENT_INFO });
      }
    }

    this.additionalDocumentsChange.emit(this.cachedAdditionalDocuments);
  }
}
